/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import './style.css';

const SystemErrorMsg = (props) => {
  const { content, closeSystemError } = props;

  return (
    <Alert bsStyle="danger"> {/* onDismiss={this.handleDismiss} */}
      <div className='danger-media'>
        <Button
          className={'sys-error-close-btn'}
          data-key={ content.closeBtn.dataKey || 'systemErrorMsg.closeBtn.text' }
          bsStyle={'link'}
          onClick={ closeSystemError }
        >
          { content.closeBtn.text }
        </Button>
        <h4 data-key={ content.title.dataKey }>
          <i className={'icon icon-triangle-error'}>{}</i>
          { content.title.text }
        </h4>
        <article className={'font-body1'}>
          <ul>
            {
              content.info.map((error, index)=> {
                return (
                  <li key={ index } data-key={ error.dataKey }>
                    { error.text }
                  </li>
                );
              })
            }
          </ul>
        </article>
      </div>
    </Alert>
  );
};

export default SystemErrorMsg;


// WEBPACK FOOTER //
// ./src/shared/SystemErrorMsg/index.js